import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const ADD_REWARD_METHOD_API_URL =
  '/api/v1/quiz/winner/reward-method/add-reward-method';
const UPDATE_REWARD_METHOD_API_URL =
  '/api/v1/quiz/winner/reward-method/update-reward-method/';
const DELETE_REWARD_METHOD_API_URL =
  '/api/v1/quiz/winner/reward-method/delete-reward/';
const GET_REWARD_METHOD_API_URL =
  '/api/v1/quiz/winner/reward-method/get-reward-method?pagination=false';
const ADD_QUESTION_IMG_API_URL =
  '/api/v1/quiz/builder/question/add-imagequestion';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class RewardMethodService {
  constructor(private http: HttpClient) {}

  getAllMethod(): Observable<any> {
    return this.http.get<any>(`${BASE_URL}${GET_REWARD_METHOD_API_URL}`);
  }

  createRewardMethod(data: any): Observable<any> {
    return this.http.post<any>(`${BASE_URL}${ADD_REWARD_METHOD_API_URL}`, data);
  }

  updateRewardMethod(data: any, id: number): Observable<any> {
    return this.http.put<any>(
      `${BASE_URL}${UPDATE_REWARD_METHOD_API_URL}${id}`,
      data
    );
  }

  deleteRewardMethod(id: number): Observable<any> {
    return this.http.delete<any>(
      `${BASE_URL}${DELETE_REWARD_METHOD_API_URL}${id}`
    );
  }
}
